import React from "react";
import { MapPin } from "lucide-react";
import { useLocale } from 'next-intl';
import { useLocalizedField } from '@/hooks/useLocalizedField';

export default function MusseCard({ item }: { item: any }) {
  const locale = useLocale();
  const { getLocalizedField } = useLocalizedField();
  
  const name = getLocalizedField(item, 'Name', item.Name || 'Unknown');
  const situation = getLocalizedField(item, 'Situation', item.Situation || 'Unknown');
  const description = getLocalizedField(item, 'Description', item.Description || '');

  return (
    <a href={`/${locale}/museums/${item.slug}`} className="relative w-full max-w-sm rounded-2xl overflow-hidden shadow-lg cursor-pointer group" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      
      {/* IMAGE */}
      <img
        src={item.vignette || item.images?.[0]}
        alt={name}
        className="w-full h-60 object-cover transition-transform duration-500 group-hover:scale-105"
      />

      {/* GRADIENT OVERLAY */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />

      {/* CONTENT */}
      <div className="absolute bottom-0 left-0 right-0 p-4 text-white space-y-2">
        {/* LOCATION */}
        <div className={`flex items-center gap-1 text-sm font-medium `}>
          <MapPin className="w-4 h-4 text-white" />
          <span>{situation}</span>
        </div>

        {/* NAME */}
        <h3 className="text-lg font-semibold truncate">
          {name}
        </h3>

        {/* DESCRIPTION (shortened) */}
        <p className="text-sm text-gray-200 line-clamp-2">
          {description ? `${description.slice(0, 100)}...` : ''}
        </p>
      </div>
    </a>
  );
}
